import React from 'react';
import { Box, useTheme } from '@mui/material';

import FlightSegment from './FlightSegment';
import { sxStyled } from '../styles';

const FlightTimes = ({
  isCustomSearch,
  common_title,
  activeRadio,
  returnTime,
  findScale,
  flightTimeConvert,
}) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const labelStyle = { fontWeight: 700, color: '#000', fontSize: '16px' };
  if (!isCustomSearch) return null;

  return (
    <Box sx={sxStyle.boxCarrierFlex}>
      <Box
        sx={{
          ...sxStyle.boxCarrier,
          marginBottom: common_title[1] ? '0px' : '20px',
        }}
      >
        <Box sx={{ marginBottom: common_title[1] ? '0px' : '20px' }}>
          <FlightSegment
            segment={activeRadio[0]}
            labelStyle={labelStyle}
            returnTime={returnTime}
            findScale={findScale}
            flightTimeConvert={flightTimeConvert}
          />
        </Box>

        {common_title[1] && (
          <Box sx={sxStyle.boxVuelta}>
            <FlightSegment
              segment={activeRadio[1]}
              labelStyle={labelStyle}
              returnTime={returnTime}
              findScale={findScale}
              flightTimeConvert={flightTimeConvert}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default FlightTimes;
